<template>
    <div class="kpi-item">
        <div class="kpi-item__label typographies-paragraph-x-small-regular">
            {{ label }}
        </div>
        <CompassTooltip
            v-if="percentage"
            :content="
                $t.__('listing.ProgressInvoiceProgressBar.progress_percentage', {
                    percentage: `${percentage}%`,
                })
            "
            placement="bottom"
        >
            <CompassProgressBar
                :state="percentage"
                type="colored"
                :lowLimit="lowLimit"
                :highLimit="highLimit"
                :caption="total"
                :staticValue="amount"
            />
        </CompassTooltip>
    </div>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        amount: {
            type: String,
            required: true,
        },
        total: {
            type: String,
            required: true,
        },
        percentage: {
            type: Number,
            required: true,
        },
        highLimit: {
            type: Number,
            default: 100,
        },
        lowLimit: {
            type: Number,
            default: 0,
        },
    },
};
</script>
<style scoped lang="scss">
.kpi-item {
    position: relative;

    &::v-deep {
        .compass-progress-bar {
            width: 220px;
        }

        .compass-tooltip__element {
            display: block;
        }
    }

    &__label {
        color: var(--colors-common-text-subtle-default);
        margin: 0 0 2px;
        text-transform: uppercase;
    }
}
</style>
